<template>
	<div>
		<template>
			<v-card elevation="0">
				<v-form class="pa-2" ref="form" lazy-validation>
					<div>
						※　期間で検索した場合、指定月の前月の棚卸しデータ・指定月の入出庫データのみ表示されます。
					</div>

					<v-menu
						ref="menu"
						v-model="menu"
						:close-on-content-click="false"
						:return-value.sync="setMonth"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								class="mt-2"
								outlined
								dense
								v-model="month"
								label="年月で検索"
								readonly
								v-bind="attrs"
								v-on="on"
							/>
						</template>
						<v-date-picker v-model="setMonth" type="month" no-title scrollable locale="ja">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false"> 閉じる </v-btn>
							<v-btn text color="secondary" @click="$refs.menu.save(month)"> 決定 </v-btn>
						</v-date-picker>
					</v-menu>

					<v-text-field label="ゴム生地名で検索" class="mt-2" outlined dense v-model="name" />

					<v-combobox
						ref="combobox"
						:items="ordered_products"
						item-text="get_processed_product_number"
						item-value="id"
						v-model="ordered_product"
						label="製造番号で検索"
						dense
						outlined
						class="mt-2"
						@keyup="setSearchProductNumber"
						@change="changeOrderedProduct"
						small-chips
						single
					/>
				</v-form>
				<v-card-actions>
					<v-row no-gutters class="pb-2">
						<v-col cols="4">
							<v-row no-gutters justify="start">
								<v-btn color="grey darken-1" text @click="resetForm"> リセット </v-btn>
							</v-row>
						</v-col>
						<v-col cols="4">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="sendParent(1)">
									<v-icon class="mr-1">mdi-magnify</v-icon>
									検索する
								</v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</template>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

export default {
	components: {},
	props: {
		month: {
			type: null,
			required: false,
		},
	},
	data() {
		return {
			required: false,
			menu: null,
			name: null,
			ordered_products: [],
			ordered_product: null,
			productNumberKeyword: null,
			searchProductNumberTimer: null,
		}
	},
	methods: {
		sendParent(page) {
			if (this.ordered_product) {
				this.$emit("send-parent", page, this.name, "", this.ordered_product.id)
			} else {
				this.$emit("send-parent", page, this.name)
			}
		},
		resetForm() {
			this.setMonth = null
			this.name = null
			this.ordered_product = null
		},
		setSearchProductNumber(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.ordered_products = []
			this.productNumberKeyword = e.target.value
			clearTimeout(this.searchProductNumberTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.productNumberKeyword.length) return // 0文字の場合はreturn
			this.searchProductNumberTimer = setTimeout(this.fetchProductNumbers, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		changeOrderedProduct() {
			// テキスト追加時の削除
			if (!this.ordered_products.includes(this.ordered_product)) {
				this.ordered_product = null
				// this.receiving_shippings = null
				this.$refs.combobox.reset()
			}
		},
		fetchProductNumbers() {
			const params = {
				q: {
					product_number_cont: this.productNumberKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_ordered_products", {
					headers,
					params,
				})
				.then((res) => {
					this.searchProductNumberTimer = null
					this.ordered_products = res.data.ordered_products
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		setMonth: {
			get() {
				return this.month
			},
			set(newVal) {
				return this.$emit("update:month", newVal)
			},
		},
	},
}
</script>
